import { get } from 'lodash';
import React from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { editPosition } from 'src/apis/position';
import EditPosition from 'src/components/position/Edit';
import NewCreatingPositionLoader from 'src/components/position/NewCreatingPositionLoader';
import { useToast } from 'src/context/ToastProvider';
import { useUserContext } from 'src/context/UserProvider';
import { useGetPositionByIdQuery } from 'src/hooks/position.hooks';
import { PositionStatus, UIPosition } from 'types';
import { Loader } from 'ui';

function EditPositionRouter() {
	const toast = useToast();
	const navigate = useNavigate();
	const queryClient = useQueryClient();
	const { jobId, companyId, positionId } = useParams();
	const { isAccountManagerLoggedIn } = useUserContext();
	const { isLoading, data: positionData } = useGetPositionByIdQuery(jobId);

	const editPositionFn = useMutation(['editPosition'], editPosition, {
		onSuccess() {
			queryClient.refetchQueries(['getPositionById', jobId]);

			if (
				positionData?.position?.hasConfirmedPublish ||
				positionData?.position?.company.isLead ||
				positionData?.position?.positionStatus === PositionStatus.CLOSED
			) {
				navigate(isAccountManagerLoggedIn ? `/positions/${companyId}/${jobId}/candidates` : '/positions');
			} else {
				navigate(`/job-preview/${isAccountManagerLoggedIn ? `${companyId}/` : ''}${jobId}`);
			}
		},
		onError(error: Error) {
			const errorMessage = get(error, ['response', 'data', 'message'], error.message);
			toast({
				type: 'error',
				title: errorMessage,
			});
		},
	});

	if (isLoading)
		return (
			<div className="mt-6">
				{/* <Loader /> */}
				<NewCreatingPositionLoader showAnimation={true} progressBar={false} customClassCss="!w-[30%] mx-auto" />
			</div>
		);

	return (
		<div className="md:py-6">
			<div className="max-w-[580px] mx-auto dark:bg-[#111E2C] bg-[#fff] p-4 md:p-6 md:rounded-lg border dark:border-0">
				<h1 className="text-xl md:text-2xl font-bold dark:text-white text-[#28293D] mb-2">Edit Position</h1>
				<EditPosition editPositionFn={editPositionFn} data={positionData?.position as UIPosition} jobId={jobId || ''} />
			</div>
		</div>
	);
}

export default EditPositionRouter;
